import Box from "@mui/material/Box";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Backdrop from "@mui/material/Backdrop";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { actionSheetFileDropped, selectorSheets } from "./spreadsheetRedux";
import {
  wbFromFile,
  getNextSheetId,
  defaultSheetFile,
  reduxSheetFile,
  jsonFromWb,
  preFormatJson,
} from "./spreadsheetutils";

const backdrop_ = (theme) => ({
  zIndex: 10,
  pointerEvents: "none",
  backgroundColor: "rgba(255,255,255,0.75)",
  color: "rgba(0,0,0,0.75)",
});

export default function DragAndDrop({ children }) {
  const [dragState, setDragState] = useState(false);
  const dispatch = useDispatch();
  const files = useSelector(selectorSheets);

  const nextId = getNextSheetId(files);

  const handleWorkbook = async (file, id) => {
    const fileName = file.name;
    const workbook = await wbFromFile(file);
    const rawJson = jsonFromWb(workbook);
    const { headerRowIndex, rmrecnbr, lnglat, type, json, preHeaderJson } =
      preFormatJson(rawJson);

    const fileObject = {
      ...defaultSheetFile(id),
      ...{
        id,
        fileName,
        rmrecnbr,
        preHeaderJson: preHeaderJson,
        json: json,
        headerRowIndex: headerRowIndex,
        lnglat,
        defaultText: rmrecnbr,
        type,
        source: "local",
        status: "complete",
      },
      ...reduxSheetFile(),
    };

    dispatch(actionSheetFileDropped(fileObject));
  };

  const handleFiles = (dropEvent) => {
    if (dropEvent.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < dropEvent.dataTransfer.items.length; i++) {
        // If dropped items aren't files or accepted file types, reject them
        if (dropEvent.dataTransfer.items[i].kind === "file") {
          let id = nextId + i;
          let file = dropEvent.dataTransfer.items[i].getAsFile();
          handleWorkbook(file, id);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < dropEvent.dataTransfer.files.length; i++) {
        let id = nextId + i;
        let file = dropEvent.dataTransfer.files[i];
        handleWorkbook(file, id);
      }
    }
  };

  const handleDragEnter = (e) => {
    setDragState(true);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    setDragState(false);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    handleFiles(e);
    setDragState(false);
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Box
      onDragEnter={(e) => handleDragEnter(e)}
      onDragLeave={(e) => handleDragLeave(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDrop={(e) => handleDrop(e)}
    >
      <Backdrop sx={backdrop_} open={dragState}>
        <SaveAltIcon fontSize="large" />
        Drop File
      </Backdrop>
      {children}
    </Box>
  );
}
